import {
  useStoryblokLink,
  useStoryblokLinkMap,
} from "../hooks/useStoryblokLinks";
import { GetWindowLanguage } from "./storyHelpers";
import { BASENAME } from "../router/constants";
import { init, compose, when, startsWith, replace, endsWith } from "ramda";
import { LANGUAGES_BY_BASENAME } from "../constants/languages";
import { locale } from "moment";

// Uses the storyblok cdn link api to get story information
// If a story is found the story object has the following fields:
// id, is_folder, is_startpage, name, parent_id, path, position,
// published, real_path, slug, uuid
function storyblokStoryUuidToUrl(story_uuid) {
  const story = useStoryblokLink(story_uuid);

  return story ? story.real_path : "";
}

// Returns undefined if a real_path story is not found
function urlToStoryblokSlug(url) {
  const links = useStoryblokLinkMap();

  for (let uuid in links) {
    if (links[uuid].real_path === url) {
      return links[uuid].slug;
    }
  }
}

function buildInternalPath(path) {
  if (!path) return path;
  if (path.startsWith(`/${BASENAME}`)) return path.replace(`/${BASENAME}`, "/");
  if (path.startsWith(BASENAME)) return path.replace(BASENAME, "");
  if (path.startsWith("/")) return path;
  return `/${path}`;
}

function articleUrlFromSlug(slug) {
  return buildInternalPath(slug);
}

function authorUrlFromSlug(slug) {
  if (slug.startsWith("/authors")) {
    slug = slug.replace("/authors/", "");
  }

  if (slug.startsWith("authors/")) {
    slug = slug.replace("authors/", "");
  }

  return buildInternalPath(`/author/${slug}`);
}

function categorySlugFromPath(path) {
  let slug = path;

  if (path.startsWith("/")) {
    slug = path.replace("/", "");
  }

  return slug;
}

function articleSlugFromPath(path) {
  let slug = path;

  if (path.startsWith("/")) {
    slug = path.replace("/", "");
  }

  return slug;
}

function authorSlugFromPath(path) {
  let slug = path;

  if (path.startsWith("/author/")) {
    slug = path.replace("/author/", "authors/");
  }

  return slug;
}

function getPathnameWithoutLocale() {
  const path = window.location.pathname;
  const lang = GetWindowLanguage();

  return lang ? path.replace(`/${lang}`, "") : path;
}

function tagNameFromPath() {
  const url = new URL(window.location).pathname;

  return decodeURIComponent(url.split("/").pop());
}

const tagPageUrlFromSlug = (slug) => {
  return buildInternalPath(`tag/${encodeURIComponent(slug)}`);
};

export {
  storyblokStoryUuidToUrl,
  urlToStoryblokSlug,
  buildInternalPath,
  articleUrlFromSlug,
  articleSlugFromPath,
  authorSlugFromPath,
  authorUrlFromSlug,
  categorySlugFromPath,
  getPathnameWithoutLocale,
  tagNameFromPath,
  tagPageUrlFromSlug,
};
